import * as actionTypes from '../actions/actionTypes'

const initialState = {
  pagination: { total: 0, to: 0, lastPage: 1, from: 0, currentPage: 1, perPage: 10 },
  data: [],
  loading: false,
  filtered: false,
  success: false,
  selectedRecord: null,
  company: [],
  form: [],
  levelGroup: [],
  org: [],
  position: [],
  filterEmps: null,
  filterItems: null,
  filterStructures: null,
  filterOptions: null,
  filterAppraisalTypes: null,
  filterCompanies: null,
  filterForms: null,
  filterLevelGroups: null,
  filterOrgs: null,
  filterPositions: null,
  filterStatus: null,
  loadingStates: [],
  appraisal: [],
  chartData: [],
  allData: [],
  filterLoading: false,
  formLoading: false
}

// fetchCompany

const fetchCompanyOptionsStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchCompanyOptionsSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    filterCompanies: action.data
  }
}

const fetchCompanyOptionsFailed = (state, action) => {
  const { errorMessage } = action
  return {
    ...state,
    loading: false,
    message: errorMessage
  }
}

// fetchForm

const fetchFormStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchFormSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    form: action.data
  }
}

const fetchFormFailed = (state, action) => {
  const { errorMessage } = action
  return {
    ...state,
    loading: false,
    message: errorMessage
  }
}

// fetchLevelGroup

const fetchLevelGroupStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchLevelGroupSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    levelGroup: action.data
  }
}

const fetchLevelGroupFailed = (state, action) => {
  const { errorMessage } = action
  return {
    ...state,
    loading: false,
    message: errorMessage
  }
}

// fetchOrg

const fetchOrgStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchOrgSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    org: action.data
  }
}

const fetchOrgFailed = (state, action) => {
  const { errorMessage } = action
  return {
    ...state,
    loading: false,
    message: errorMessage
  }
}

// fetchPosition

const fetchPositionStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchPositionSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    position: action.data
  }
}

const fetchPositionFailed = (state, action) => {
  const { errorMessage } = action
  return {
    ...state,
    loading: false,
    message: errorMessage
  }
}

// fetchEmp

const fetchEmpStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchEmpSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    emp: action.data
  }
}

const fetchEmpFailed = (state, action) => {
  const { errorMessage } = action
  return {
    ...state,
    loading: false,
    message: errorMessage
  }
}

// fetchAppraisalType

const fetchAppraisalTypeStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchAppraisalTypeSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    appraisal: action.data
  }
}

const fetchAppraisalTypeFailed = (state, action) => {
  const { errorMessage } = action
  return {
    ...state,
    loading: false,
    message: errorMessage
  }
}

// fetchStructureForPerformanceTrend

const fetchStructureForPerformanceTrendStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchStructureForPerformanceTrendSuccess = (state, action) => {
  const { data } = action
  return {
    ...state,
    loading: false,
    filterStructures: data
  }
}

const fetchStructureForPerformanceTrendFailed = (state, action) => {
  const { errorMessage } = action
  return {
    ...state,
    loading: false,
    message: errorMessage
  }
}

// fetchItemForPerformanceTrend

const fetchItemForPerformanceTrendStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchItemForPerformanceTrendSuccess = (state, action) => {
  const { data } = action
  return {
    ...state,
    loading: false,
    filterItems: data
  }
}

const fetchItemForPerformanceTrendFailed = (state, action) => {
  const { errorMessage } = action
  return {
    ...state,
    loading: false,
    message: errorMessage
  }
}

// fetchDashboardPerformanceTrendChart

const fetchDashboardPerformanceTrendChartStart = (state, action) => {
  return {
    ...state,
    filterLoading: true,
    filtered: false
  }
}

const fetchDashboardPerformanceTrendChartSuccess = (state, action) => {
  const { data } = action
  return {
    ...state,
    filtered: true,
    filterLoading: false,
    chartData: data
  }
}

const fetchDashboardPerformanceTrendChartFailed = (state, action) => {
  const { errorMessage } = action
  return {
    ...state,
    filtered: false,
    filterLoading: false,
    message: errorMessage
  }
}

// fetchDashboardPerformanceTrendAll

const fetchDashboardPerformanceTrendAllStart = (state, action) => {
  return {
    ...state,
    formLoading: true
  }
}

const fetchDashboardPerformanceTrendAllSuccess = (state, action) => {
  const { data } = action
  return {
    ...state,
    allData: data,
    formLoading: false
  }
}

const fetchDashboardPerformanceTrendAllFailed = (state, action) => {
  const { errorMessage } = action
  return {
    ...state,
    message: errorMessage,
    formLoading: false
  }
}

// api/dropdown/employee_detail

const fetchEmpDetailOptionsStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'emp_detail_id'] }
}

const fetchEmpDetailOptionsSuccess = (state, action) => {
  const { data } = action
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'emp_detail_id'),
    filterEmps: data
  }
}

const fetchEmpDetailOptionsFailed = (state, action) => {
  const { errorMessage } = action
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'emp_detail_id'),
    message: errorMessage
  }
}

const fetchAppraisalTypeOptionsStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'appraisal_type_id']
  }
}

const fetchAppraisalTypeOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'appraisal_type_id'),
    filterAppraisalTypes: data
  }
}

const fetchAppraisalTypeOptionsFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'appraisal_type_id')
  }
}

const fetchFormOptionsStart = state => {
  return { ...state, loadingStates: [...state.loadingStates, 'form_id'] }
}

const fetchFormOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'form_id'),
    filterForms: data
  }
}

const fetchFormOptionsFailed = state => {
  return { ...state, loadingStates: state.loadingStates.filter(item => item !== 'form_id') }
}

const fetchLevelGroupOptionsStart = state => {
  return { ...state, loadingStates: [...state.loadingStates, 'level_group_id'] }
}

const fetchLevelGroupOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'level_group_id'),
    filterLevelGroups: data
  }
}

const fetchLevelGroupOptionsFailed = state => {
  return { ...state, loadingStates: state.loadingStates.filter(item => item !== 'level_group_id') }
}

const fetchOrganizationOptionsStart = state => {
  return { ...state, loadingStates: [...state.loadingStates, 'org_id'] }
}

const fetchOrganizationOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'org_id'),
    filterOrgs: data
  }
}

const fetchOrganizationOptionsFailed = state => {
  return { ...state, loadingStates: state.loadingStates.filter(item => item !== 'org_id') }
}

const fetchPositionOptionsStart = state => {
  return { ...state, loadingStates: [...state.loadingStates, 'position_id'] }
}

const fetchPositionOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'position_id'),
    filterPositions: data
  }
}

const fetchPositionOptionsFailed = state => {
  return { ...state, loadingStates: state.loadingStates.filter(item => item !== 'position_id') }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FOR_APPRAISAL_START:
      return fetchAppraisalTypeOptionsStart(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchAppraisalTypeOptionsSuccess(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchAppraisalTypeOptionsFailed(state, action)
    // FETCH_COMPANY_OPTIONS
    case actionTypes.FETCH_COMPANY_OPTIONS_START:
      return fetchCompanyOptionsStart(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_SUCCESS:
      return fetchCompanyOptionsSuccess(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FAILED:
      return fetchCompanyOptionsFailed(state, action)
    // FETCH_APPRAISAL_TYPE_OPTIONS
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_START:
      return fetchAppraisalTypeStart(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_SUCCESS:
      return fetchAppraisalTypeSuccess(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FAILED:
      return fetchAppraisalTypeFailed(state, action)
    // FETCH_FORM_OPTIONS
    case actionTypes.FETCH_FORM_OPTIONS_START:
      return fetchFormStart(state, action)
    case actionTypes.FETCH_FORM_OPTIONS_SUCCESS:
      return fetchFormSuccess(state, action)
    case actionTypes.FETCH_FORM_OPTIONS_FAILED:
      return fetchFormFailed(state, action)
    // FETCH_LEVEL_GROUP_OPTIONS
    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_START:
      return fetchLevelGroupStart(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_SUCCESS:
      return fetchLevelGroupSuccess(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FAILED:
      return fetchLevelGroupFailed(state, action)
    // FETCH_ORGANIZATION_OPTIONS
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_START:
      return fetchOrgStart(state, action)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_SUCCESS:
      return fetchOrgSuccess(state, action)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FAILED:
      return fetchOrgFailed(state, action)
    // FETCH_POSITION_OPTIONS
    case actionTypes.FETCH_POSITION_OPTIONS_START:
      return fetchPositionStart(state, action)
    case actionTypes.FETCH_POSITION_OPTIONS_SUCCESS:
      return fetchPositionSuccess(state, action)
    case actionTypes.FETCH_POSITION_OPTIONS_FAILED:
      return fetchPositionFailed(state, action)
    // FETCH_EMPLOYEE_OPTIONS
    case actionTypes.FETCH_EMPLOYEE_OPTIONS_START:
      return fetchEmpStart(state, action)
    case actionTypes.FETCH_EMPLOYEE_OPTIONS_SUCCESS:
      return fetchEmpSuccess(state, action)
    case actionTypes.FETCH_EMPLOYEE_OPTIONS_FAILED:
      return fetchEmpFailed(state, action)
    // FETCH_STRUCTURE_OPTIONS_FOR_PERFORMANCE_TREND
    case actionTypes.FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_START:
      return fetchStructureForPerformanceTrendStart(state, action)
    case actionTypes.FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchStructureForPerformanceTrendSuccess(state, action)
    case actionTypes.FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchStructureForPerformanceTrendFailed(state, action)
    // FETCH_ITEM_OPTIONS_FOR_PERFORMANCE_TREND (KPI)
    case actionTypes.FETCH_ITEM_OPTIONS_FOR_PERFORMANCE_TREND_START:
      return fetchItemForPerformanceTrendStart(state, action)
    case actionTypes.FETCH_ITEM_OPTIONS_FOR_PERFORMANCE_TREND_SUCCESS:
      return fetchItemForPerformanceTrendSuccess(state, action)
    case actionTypes.FETCH_ITEM_OPTIONS_FOR_PERFORMANCE_TREND_FAILED:
      return fetchItemForPerformanceTrendFailed(state, action)
    // FETCH_DASHBOARD_PERFORMANCE_TREND_CHART
    case actionTypes.FETCH_DASHBOARD_PERFORMANCE_TREND_CHART_START:
      return fetchDashboardPerformanceTrendChartStart(state, action)
    case actionTypes.FETCH_DASHBOARD_PERFORMANCE_TREND_CHART_SUCCESS:
      return fetchDashboardPerformanceTrendChartSuccess(state, action)
    case actionTypes.FETCH_DASHBOARD_PERFORMANCE_TREND_CHART_FAILED:
      return fetchDashboardPerformanceTrendChartFailed(state, action)
    // FETCH_DASHBOARD_PERFORMANCE_TREND_ALL
    case actionTypes.FETCH_DASHBOARD_PERFORMANCE_TREND_ALL_START:
      return fetchDashboardPerformanceTrendAllStart(state, action)
    case actionTypes.FETCH_DASHBOARD_PERFORMANCE_TREND_ALL_SUCCESS:
      return fetchDashboardPerformanceTrendAllSuccess(state, action)
    case actionTypes.FETCH_DASHBOARD_PERFORMANCE_TREND_ALL_FAILED:
      return fetchDashboardPerformanceTrendAllFailed(state, action)
    // FETCH_EMPLOYEE_DETAIL_OPTIONS
    case actionTypes.FETCH_EMPLOYEE_DETAIL_OPTIONS_START:
      return fetchEmpDetailOptionsStart(state, action)
    case actionTypes.FETCH_EMPLOYEE_DETAIL_OPTIONS_SUCCESS:
      return fetchEmpDetailOptionsSuccess(state, action)
    case actionTypes.FETCH_EMPLOYEE_DETAIL_OPTIONS_FAILED:
      return fetchEmpDetailOptionsFailed(state, action)

    case actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_START:
      return fetchFormOptionsStart(state, action)
    case actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchFormOptionsSuccess(state, action)
    case actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchFormOptionsFailed(state, action)

    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_START:
      return fetchLevelGroupOptionsStart(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchLevelGroupOptionsSuccess(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchLevelGroupOptionsFailed(state, action)

    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_START:
      return fetchOrganizationOptionsStart(state, action)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchOrganizationOptionsSuccess(state, action)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchOrganizationOptionsFailed(state, action)

    case actionTypes.FETCH_POSITION_OPTIONS_FOR_APPRAISAL_START:
      return fetchPositionOptionsStart(state, action)
    case actionTypes.FETCH_POSITION_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchPositionOptionsSuccess(state, action)
    case actionTypes.FETCH_POSITION_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchPositionOptionsFailed(state, action)

    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    // DEFAULT
    default:
      return state
  }
}

export default reducer
